"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Video_1 = require("@CommonFrontend/ContentTokens/DataModels/Video");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var getYoutubeId = require("@CommonFrontend/VideoBackground/GetYoutubeId").default;
var Video = function (_a) {
    var attributes = _a.attributes, embedUrl = _a.embedUrl, width = _a.width, isPrintMode = _a.isPrintMode, publicPageLink = _a.publicPageLink;
    if (!embedUrl) {
        return null;
    }
    var updatedEmbedUrl = (0, Video_1.updateEmbedUrlPrefix)(embedUrl);
    if (isPrintMode) {
        var youtubeId = getYoutubeId("https:".concat(updatedEmbedUrl));
        return printVideoWidget(youtubeId, publicPageLink, width);
    }
    return (react_1.default.createElement("figure", { style: attributes.style, className: (0, classnames_1.default)(attributes.className, "embed-widget__container") },
        react_1.default.createElement("div", { className: "embed-widget__iframe-container" },
            react_1.default.createElement("iframe", { src: updatedEmbedUrl, title: "Video", frameBorder: "0", allowFullScreen: true, className: "embed-widget__iframe" }))));
};
var genericThumbnail = function () { return "\n  <div class=\"print-background\">\n    <!-- Show a generic background 'cloud' if we were unable to get a url for an image thumbnail -->\n    <img class=\"cloud\" src=\"/Assets/Images/cloud-bg.svg\"/>\n  </div>\n"; };
var customThumbnail = function (youtubeId) {
    var thumbnailUrl = youtubeId ? "https://img.youtube.com/vi/".concat(youtubeId, "/maxresdefault.jpg") : "";
    return "\n    <div class=\"print-background thumbnail-background\">\n      <img class=\"thumbnail custom-thumbnail\" src=\"".concat(thumbnailUrl, "\"/>\n    </div>\n  ");
};
var printVideoWidget = function (youtubeId, publicPageLink, width) {
    var wrapperWidth = 100;
    var wrapperPaddingBottom = 55;
    var fontSizePx = 15;
    var videoIconWidthPx = 50;
    if (width && typeof width === "number") {
        fontSizePx *= width / 100;
        videoIconWidthPx *= width / 100;
        wrapperWidth *= width / 100;
        wrapperPaddingBottom *= width / 100;
    }
    var wrapperStyle = "width: ".concat(wrapperWidth, "%; height: 0; padding-bottom: ").concat(wrapperPaddingBottom, "%;");
    var background = youtubeId ? customThumbnail(youtubeId) : genericThumbnail();
    var videoLinkHtml = publicPageLink
        ? "<div class=\"online-link\">\n            <a href=\"".concat(publicPageLink, "\" target=\"_blank\">\n              <div>View online</div>\n              <img src=\"/Assets/icons/arrow-emerald-circle.svg\" alt=\"\"/>\n            </a>\n          </div>")
        : "";
    return (react_1.default.createElement("div", { className: "video-content", dangerouslySetInnerHTML: {
            __html: "<div class=\"print-placeholder avoid-page-break\" style=\"".concat(wrapperStyle, "\">\n        ").concat(background, "\n        <div class=\"print-message\">\n          <img\n            class=\"offline-icon video-icon\"\n            src=\"/Assets/icons/block-video-75.svg\"\n            style=\"width: ").concat(videoIconWidthPx, "px;\"\n          />\n          <div class=\"description\" style=\"font-size: ").concat(fontSizePx, "px;\">Video content can't be viewed offline</div>\n          ").concat(videoLinkHtml, "\n        </div>\n      </div>"),
        } }));
};
exports.default = Video;
